import cepFieldComponent from "@/components/child/form/cepfield.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import cpfComponent from "@/components/child/form/cpf.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import EditComponentBase from "@/components/parent/crud/editComponentBase";
import { Component } from "@/decorators";
import CepModel from "@/models/cepModel";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import Ufs from "@/models/enum/ufs";
import RepresentanteModel from "@/models/representanteModel";
import CidadeService from "@/services/external/cidadeService";
import RepresentanteService from "@/services/representanteService";

import "../crud.scss";

@Component({
    components: {
        textareaComponent,
        fieldsetComponent,
        comboComponent,
        checkboxComponent,
        cpfComponent,
        cepFieldComponent,
        dateTimePickerComponent,
        dataTooltipComponent,
    },
})
export default class RepresentanteEditComponent extends EditComponentBase<RepresentanteModel> {
    private cidadeService = new CidadeService();

    ufOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);
    cidadesOptions: Array<Object> = [];

    public async onLoadModel(data: RepresentanteModel) {
        await this.onLoadCidades(data.estadoId);
    }

    public async onPreSave() {
        if (this.model.cidadeId) {
            this.model.cidade = this.cidadesOptions.find(item => item["value"] == this.model.cidadeId)?.["text"];
        }
        return true;
    }

    private async onCepChanged(data: CepModel) {
        this.model.bairro = data.bairro;
        this.model.complemento = data.complemento;
        this.model.endereco = data.endereco;
        this.model.estadoId = data.uf;
        await this.onLoadCidades(data.uf);
        this.model.cidadeId = data.cidadeId;
    }

    private onCepInvalid() {
        this.$showInfo("Pesquisa por CEP", "A pesquisa não encontrou resultados");
    }

    private async onLoadCidades(estadoId: number) {
        try {
            this.cidadesOptions = [];
            if (estadoId) {
                this.cidadesOptions = await this.cidadeService.get(estadoId).withLoading();
            }
        } catch {}
    }

    public async mounted() {
        await this.setPropsCached(RepresentanteService, "Representante", new RepresentanteModel(), this.isModal, false);
    }
}
